<template>
    <div class="shop-cart-area">
      <div class="container">
          <div class="shop-cart-content">
              <table class="table">
                  <thead>
                      <tr >
                        <th class="text-center" v-for="(item,i) in shoppingCart.tableHead" :key="i">{{item.title}}</th>
                      </tr><!--/tr-->
                  </thead><!--/thead-->
                  <tbody>
                      <tr v-for="(item,i) in shoppingCart.tableContent" :key="i">
                        <!-- 1st row -->
                        <td class="product-img">
                            <img class="img-responsive" :src="item.img" alt="images">
                        </td>
                        <!-- /product-img -->

                        <td class="product-name_cart">
                            <router-link :to="item.path">{{item.title}}</router-link>
                        </td>
                        <!-- /product-name -->

                        <td class="product-price">
                            $ {{item.price}}
                        </td>
                        <!-- /product-Price -->

                        <td class="product-qty">
                            <form class="quantity-form" action="#" method="post">
                                <input type="button" value="-" class="qtyminus">
                                <input type="text" value="0" class="input-text qty text amount">
                                <input type="button" value="+" class="qtyplus">
                            </form>
                        </td>

                        <td class="product-total">
                            $ {{item.total}}
                        </td>

                        <td class="product-delete">
                            <a href="#"><i class="fa fa-pencil mrg-right-30"></i></a>
                            <a href="#"><i class="fa fa-trash-o"></i></a>
                        </td>

                      </tr>

                  </tbody><!--/tbody-->
              </table><!--/table-->
          </div><!--/.shop-cart-content-->

          <div class="cupon_shop_cart">
              <div class="row">
                  <div class="col-sm-6">
                      <input class="form-control submit_cupon" type="email" placeholder="Enter Coupon Code">
                      <input class="form-control submit_cupon_submit" type="submit" value="SUBMIT">
                  </div><!--/.col-->

                  <div class="col-sm-6">
                      <div class="pull-right_shop_Cart">
                          <router-link to="/" class="Contuning_shop_Cart">
                            Continue Shopping <i class="fa fa-play"></i>
                          </router-link>
                      </div><!--/.pull-right_shop_Cart-->
                  </div><!--/.col-->
              </div><!--/.row-->
          </div><!--/.cupon_shop_cart-->

          <div class="update_Cart_shop_area">
              <div class="row">
                  <div class="col-sm-12">
                      <h3 class="text-center">Cart Totals</h3>
                      <div class="cart-totals">
                          <table class="table">
                              <tbody>
                                  <tr>
                                      <th class="same_clasS">Cart Subtotal</th>
                                      <td class="same_clasS">${{shoppingCart.cartSubTotal}}</td>
                                  </tr>

                                  <tr class="grand-total">
                                      <th class="same_clasS">Order Total</th>
                                      <td class="same_clasS">${{shoppingCart.cartOrderTotal}}</td>
                                  </tr>

                              </tbody><!--/tbody-->
                          </table><!--/table-->
                          <div class="text-center Update_proceed_div">
                              <div class="shop-cart-btn">
                                  <router-link to='/' class="shop-cart-view">
                                      update cart
                                  </router-link>
                              </div><!--/.about-btn shop-cart-->
                              <div class="shop-cart-btn">
                                  <router-link to="/checkout" class="shop-cart-view">
                                    checkout
                                  </router-link>
                              </div><!--/.about-btn shop-cart-->
                          </div><!--/.Update_proceed_div-->
                      </div><!--/.cart-totals-->
                  </div><!--/.col-->
              </div><!--/.row-->
          </div><!--/.update_Cart_shop_area-->
      </div><!--/.container-->

  </div><!--/.shop-cart-area-->
</template>


<script>
  export default {
    data() {
      return {
        shoppingCart:{
          tableHead:[
            {title:'Product'},
            {title:''},
            {title:'Price'},
            {title:'Quantity'},
            {title:'Sub Total'},
            {title:'Edit/Delete'}
          ],
          tableContent:[
            {
              img: 'assets/images/cart/c1.jpg',
              path: '/laptop',
              title: 'laptop',
              price: '125.00',
              total: '125.00'
            },
            {
              img: 'assets/images/cart/c2.jpg',
              path: '/desktop',
              title: 'desktop',
              price: '125.00',
              total: '125.00'
            }
          ],
          cartSubTotal: '118',
          cartOrderTotal: '118'
        }
      }
    },
    mounted() {
      this.cartQuantity();
    },
    methods: {
      cartQuantity(){
        $(".qtyplus").on("click", function(){
          var b = $(this).parents(".quantity-form").find("input.qty"),
                  c = parseInt(b.val(), 10) + 1,
                  d = parseInt(b.attr("max"), 10);
              d || (d = 9999999999), c <= d && (b.val(c), b.change())
        });
        $(".qtyminus").on("click", function(){
          var b = $(this).parents(".quantity-form").find("input.qty"),
                c = parseInt(b.val(), 10) - 1,
                d = parseInt(b.attr("min"), 10);
            d || (d = 0), c >= d && (b.val(c), b.change())
        });
      }
    }
  }
</script>
